/**
 * Anna Maria zelf: haar foto, en een antwoord van haar in een blauw vak.
 *
 *   <AnnaMariaFoto />                         groot en rond, op het welkomstscherm
 *   <AnnaMariaZegt>Mooi gezien.</AnnaMariaZegt>  de feedback op een open vraag
 */
import React from 'react';
import { stijlen } from '../stijlen';

export const FOTO = '/Anna_Maria_hoofd.png';

export function AnnaMariaFoto() {
  return (
    <img
      src={FOTO}
      alt="Anna Maria"
      style={{
        width: 150,
        height: 150,
        borderRadius: '50%',
        objectFit: 'cover',
        marginBottom: 24,
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      }}
    />
  );
}

export function AnnaMariaZegt({ children, style }) {
  return (
    <div style={{ padding: 12, background: stijlen.annaMariaVerloop, borderRadius: 8, display: 'flex', gap: 12, ...style }}>
      <img src={FOTO} alt="Anna Maria" style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }} />
      <div>{children}</div>
    </div>
  );
}
